import { useEffect } from "react";
import styles from "../floorplans.module.scss";
import FloorPlanListCard from "./floorplanListCard";
import Pagination from "../../Pagination/pagination";
import { formatResultCount, getBreadcrumbUrl } from "../../../utils/util";
import { traceEvent } from "../../../utils/tracing";
import FloorplanSkelton from "./floorplanSkelton/floorplanSkelton";
import CommunityCostGuide from "./communityCostGuide";
export default function FloorplanList({
  data,
  typeListing,
  page,
  setPage,
  loading,
  contactLink,
  params,
  moveInStartDate,
  setIsUserInteraction,
  setIsPaginationInteraction,
}) {
  let dataToDisplay = data?.fp || [];

  useEffect(() => {
    if (!loading && data && !sessionStorage.getItem("resultPageTracked")) {
      sessionStorage.setItem("resultPageTracked", "true");
      traceEvent("RESULT_PAGE_LOAD");
    }
  }, [data, loading]);

  // This function handles the page change event.
  // It updates the page state with the new page number.
  const handlePageChange = (page) => {
    setIsPaginationInteraction(true);
    setPage(parseInt(page));
    setIsUserInteraction(true);
  };

  // This conditional sets the dataToDisplay to the units of the first floorplan if typeListing is false and there are floorplans available.
  if (!typeListing && data?.fp?.length > 0) {
    dataToDisplay = data?.fp[0]?.units || [];
  }

  // Check if any floorplan has virtual tour URL
  const hasAnyVirtualTour = typeListing 
    ? dataToDisplay?.some(item => item?.virtual_tour_url)
    : dataToDisplay?.some(item => item?.virtual_tour_url);

  if (loading) {
    return (
      <div className={styles.FloorplanList}>
        <FloorplanSkelton />
      </div>
    );
  }

  // This conditional renders an error message if there are no results.
  if (data?.total === 0) {
    return (
      <div className={styles.FloorplanList}>
        <div className={styles.errorContainer}>
          <div>
            <h3>No results found</h3>
            <p>
              {data?.config?.no_result_message?.split("contact [url]")[0]}
              <a href={data?.config?.contact_page_url}>contact</a>
              {data?.config?.no_result_message?.split("contact [url]")[1]}
            </p>
          </div>
        </div>
        <CommunityCostGuide />
      </div>
    );
  }

  return (
    <div className={styles.FloorplanList}>
      {!typeListing && dataToDisplay?.length > 0 && (
        <>
          <p className={styles.InnerNav}>
            <a
              href={getBreadcrumbUrl(params)}
              onClick={() => traceEvent("FLOORPLANS_RETURN_TO_RESULTS")}
            >
              Floor Plan
            </a>
            &nbsp;/&nbsp;
            <a onClick={() => traceEvent("FLOORPLANS_RETURN_TO_RESULTS")}>
              {dataToDisplay[0]?.floorplan_name}
            </a>
          </p>
          <p className={styles.FloorplanName}>
            {dataToDisplay[0]?.floorplan_name}
          </p>
        </>
      )}

      {data?.total > 0 ? (
        <>
          <p className={styles.ResultsCount}>
            Showing {formatResultCount(data?.total)} results
          </p>

          <div className={styles.FloorplanListContainer}>
            {dataToDisplay?.map((item, index) => (
              <FloorPlanListCard
                typeListing={typeListing}
                key={`${item?.id}${index}`}
                data={item}
                fpData={typeListing ? data?.fp[index] : data?.fp[0]}
                specials={data?.specials}
                contactLink={contactLink}
                params={params}
                moveInStartDate={moveInStartDate}
                hasAnyVirtualTour={hasAnyVirtualTour}
              />
            ))}
          </div>
        </>
      ) : (
        <div className={styles.FloorplanList}>
          <div className={styles.errorContainer}>
            <div>
              <h3>No results found</h3>
              <p>
                {data?.config?.no_result_message?.split("contact [url]")[0]}
                <a href={data?.config?.contact_page_url}>contact</a>
                {data?.config?.no_result_message?.split("contact [url]")[1]}
              </p>
            </div>
          </div>
        </div>
      )}
   
      <div className={styles.footerDisclaimer}>
        Floor plans are artist’s rendering. All dimensions are approximate.
        Actual product and specifications may vary in dimension or detail. Not
        all features are available in every apartment. Prices and availability
        are subject to change and may not be reflective of the selected move-in
        date. For questions, please contact our leasing team.
      </div>
      {data?.total > 0 && (
        <Pagination
          currentPage={page}
          totalPages={Math.ceil(data?.total / data?.perpage)}
          onPageChange={handlePageChange}
        />
      )}
      <CommunityCostGuide />
    </div>
  );
}
